import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../components/common/Button';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="bg-white rounded-lg shadow-md p-6">
        
        <h1 className="text-2xl font-bold text-center text-blue-700 mb-6">
          {t('privacy.title')}
        </h1>
        
        <div className="space-y-6">
          
          <section>
            <div className="space-y-3 text-gray-700 text-justify">
              <p>{t('privacy.intro1')}</p>
              <p>{t('privacy.intro2')}</p>
              <p>{t('privacy.intro3')}</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.section1Title')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.section1Content')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.cameraStorageTitle')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.cameraStorageContent')}
            </p>
          </section>

          <section>
            <p className="text-gray-700 text-justify">
              {t('privacy.thirdParty')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.logTitle')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.logContent')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.cookiesTitle')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.cookiesContent')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.serviceProvidersTitle')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.serviceProvidersContent')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.dataDeletionTitle')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.dataDeletionContent')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.securityTitle')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.securityContent')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.linksTitle')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.linksContent')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.childrenTitle')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.childrenContent')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.changesTitle')}
            </h2>
            <p className="text-gray-700 text-justify">
              {t('privacy.changesContent')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('privacy.contactTitle')}
            </h2>
            <p className="text-gray-700 text-justify whitespace-pre-line mb-4">
              {t('privacy.contactContent')}
            </p>
            <p className="text-gray-700 font-medium italic text-justify">
              {t('privacy.effectiveDate')}
            </p>
          </section>

        </div>
        
        <div className="mt-8 flex justify-center">
          <Button
            onClick={() => navigate('/')}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded"
          >
            {t('aboutUs.backToHome')}
          </Button>
        </div>
        
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;